import {
  GET_RECIPE_BY_PRODUCT,
  INNER_CONSOLIDATED_MULTIPLE_PRODUCT,
  OUTER_CONSOLIDATED_MULTIPLE_PRODUCT
} from './ApiConstants';
import api from './ApiHandler';

export const getRecipeByProduct = async (payload: any) => {
  return await api.get(GET_RECIPE_BY_PRODUCT, { params: payload });
};

export const getConsolidatedRecipeByMultipleProduct = async (payload: any) => {
  return await api.get(OUTER_CONSOLIDATED_MULTIPLE_PRODUCT, { params: payload });
};

export const getInnerConsolidatedRecipe = async (payload: any) => {
  return await api.get(INNER_CONSOLIDATED_MULTIPLE_PRODUCT, { params: payload });
};
